"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardDrag = void 0;
var tslib_1 = require("tslib");
var react_dnd_1 = require("react-dnd");
var react_1 = require("react");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var useBeforeDrag_1 = require("./useBeforeDrag");
function basicDragCollect(monitor) {
    return {
        isDragging: monitor.isDragging(),
        item: monitor.getItem(),
    };
}
function useDashboardDrag(_a, deps) {
    var dragItem = _a.dragItem, _b = _a.canDrag, canDrag = _b === void 0 ? true : _b, _c = _a.hideDefaultPreview, hideDefaultPreview = _c === void 0 ? true : _c, dragEnd = _a.dragEnd, dragStart = _a.dragStart;
    if (deps === void 0) { deps = []; }
    var _d = tslib_1.__read(react_dnd_1.useDrag(function () {
        var item = isFunction_1.default(dragItem) ? dragItem() : dragItem;
        return {
            type: item.type,
            item: dragItem,
            collect: basicDragCollect,
            canDrag: canDrag,
            end: dragEnd,
        };
    }, deps), 3), collectedProps = _d[0], dragRef = _d[1], dragPreviewRef = _d[2];
    var beforeDrag = useBeforeDrag_1.useBeforeDrag();
    var onInternalDragStart = react_1.useCallback(function (item) {
        beforeDrag();
        if (dragStart) {
            dragStart(item);
        }
    }, [dragStart, beforeDrag]);
    var hasHandledStart = react_1.useRef(false);
    react_1.useEffect(function () {
        if (collectedProps.isDragging) {
            if (!hasHandledStart.current) {
                var item = isFunction_1.default(dragItem) ? dragItem() : dragItem;
                hasHandledStart.current = true;
                onInternalDragStart(item);
            }
        }
        else {
            hasHandledStart.current = false;
        }
    }, [collectedProps.isDragging, onInternalDragStart, dragItem]);
    react_1.useEffect(function () {
        if (hideDefaultPreview) {
            // this is the way how to hide native drag preview, custom preview is rendered by DragLayer
            dragPreviewRef(react_dnd_html5_backend_1.getEmptyImage(), { captureDraggingState: false });
        }
    }, [dragPreviewRef, hideDefaultPreview]);
    return [collectedProps, dragRef];
}
exports.useDashboardDrag = useDashboardDrag;
//# sourceMappingURL=useDashboardDrag.js.map